/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from "react";
import { Modal, Select } from "antd";

interface DefaultProfileTypeModalProps {
  isOpen: boolean;
  onOk: () => void;
  onClose: () => void;
  selectedProfile: string;
  setSelectedProfile: (value: string) => void;
}

const DefaultProfileTypeModal: React.FC<DefaultProfileTypeModalProps> = ({
  isOpen,
  onOk,
  onClose,
  selectedProfile,
  setSelectedProfile
}) => {
  const [defaultProfileList, setDefaultProfileList] = useState<any[]>([
    {
      title: "Tourist",
      value: "Tourist"
    },
    {
      title: "Visiting relatives",
      value: "VisitingRelatives"
    },
    {
      title: "Working",
      value: "Working"
    },
    {
      title: "Business",
      value: "Business"
    },
    {
      title: "Other",
      value: "Other"
    }
  ]);

  return (
    <Modal
      title={"🔍 Select Default Visa Profile"}
      open={isOpen}
      onOk={onOk}
      onCancel={onClose}
      okText={"Select this profile"}
      cancelText={"I will fill it manually"}
    >
      <div className="flex flex-col gap-4 mt-4">
        <p className="font-bold">
          Since this is your first time registering, please select a sample
          profile based on your purpose of entry. This will help us processing
          your visa application faster.
        </p>
        <Select
          className="w-full"
          placeholder="Select a default profile"
          value={selectedProfile}
          onChange={(value) => setSelectedProfile(value)}
        >
          {defaultProfileList.map((item, index) => (
            <Select.Option key={index} value={item.value}>
              {item.title}
            </Select.Option>
          ))}
        </Select>
      </div>
    </Modal>
  );
};

export default DefaultProfileTypeModal;
